import * as Common from '../mc/Common';
import axios from 'axios';
import { components } from "react-select";

export const handleInputChange = (value) => {
    // setInputValue(value);
}

export const fetchLeadMandatory = (searchString, branch, agent, agentlocation) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'leadmandatory',
        srch: searchString,
        branch: branch,
        agent: agent,
        agentlocation: agentlocation
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchIndividualProfilePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'individual',
        srch: searchString,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchLedgerAllowedPicklist = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'ledger',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchBankDetailsPicklist = (searchString, location, bank) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'bankDetails',
        srch: searchString,
        location: location,
        bank: bank
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}

export const fetchLedgerPicklistByType = (searchString, grouptype, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'ledgerfromtype',
        srch: searchString,
        grouptype: grouptype,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchEremitAgentPickList = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'eremitagent',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCountryPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'country',
        srch: searchString,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchStatePicklist = (searchString, country) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'state',
        srch: searchString,
        country: country,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchDistrictPicklist = (searchString, state) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'district',
        srch: searchString,
        state: state,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCityPicklist = (searchString, district) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'city',
        srch: searchString,
        district: district,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCountryofIssuePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'countryIssue',
        srch: searchString,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchIndividualMainPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'individualList',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchExecutivePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'executive',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchSubExecutivePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'sub_executive',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchUTRNoPicklist = (searchString, knockoffType) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'UTR',
        srch: searchString,
        knockoffType: knockoffType
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const formatOptionLabel = ({ ID, label, desc }) => {
    const valArr = desc.split("^");
    const headerLength = valArr.length;
    // const id = valArr[0];
    // const name = valArr[1];
    // const panId = valArr[2];
    // const idtype = valArr[3];
    // const idNum = valArr[4];
    // const add = valArr[5];

    return (
        <div style={{ width: '100%', display: 'flex', borderRight: '2px solid black', paddingBottom: '0px' }}>
            {valArr.map((data) =>
                <div style={{ display: 'table-cell', width: `${100 / (headerLength)}%`, paddingLeft: '1%' }}>
                    {data}
                </div>
            )}
            {/* <div style={{ display: 'table-cell', width: '28%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}> <FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faUser} />{id + " " + name}</span>
            </div>
            <div style={{ display: 'table-cell', width: '22%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}><FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faIdCard} />{panId}</span>
            </div>
            <div style={{ display: 'table-cell', width: '35%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}><FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faAddressCard} />{idtype + " " + idNum} </span>
            </div>
            <div style={{ display: 'table-cell', width: '15%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}><FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faLocationDot} />{add}</span>
            </div> */}
        </div>
    )
}

export const menu = (props) => (
    <components.Menu {...props}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ width: '100%' }}>
                {/* <tr style={{ width: '100%' }}> */}
                {/* <th >Name</th>
                    <th >Pancard No</th>
                    <th >Id</th>
                    <th >Addressss</th> */}
                <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa', }}>
                    <div style={{ width: '28%', paddingLeft: '3%' }}>Name</div>
                    <div style={{ width: '22%', paddingLeft: '3%' }}>Pancard no</div>
                    <div style={{ width: '35%', paddingLeft: '3%' }}>Id</div>
                    <div style={{ width: '15%', paddingLeft: '3%' }}>Country</div>
                </tr>
                {/* </tr> */}
            </thead>
            <tbody >
                {props.children}
            </tbody>
        </table>
        {/* <div style={{ display: 'table', width: '100%', borderCollapse: 'collapse' }}>
            <div style={{ display: 'table-header-group', backgroundColor: '#f8f9fa', borderBottom: '2px solid #ddd' }}>
                <div style={{ display: 'table-row' }}>
                    
                </div>
            </div>
            <div style={{ display: 'table-body-group' }}>
            </div>
        </div> */}
    </components.Menu>
);

export const utrFormatOptionLabel = ({ id, label }) => {
    const valArr = label.split(" ");
    console.log(valArr);
    let total = valArr[0];
    let knockoff = valArr[1];
    let pending = valArr[2];
    let reference = valArr[3];
    let date = valArr[4];
    let bank = valArr[5] + ' ' + valArr[6];

    return (
        <div style={{ width: '100%', display: 'flex', paddingBottom: '0px' }}>
            <>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {total}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {knockoff}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {pending}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {reference}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {date}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {bank}
                </div>
            </>
        </div>
    )
}

export const UtrKnockOffmenu = (props) => (
    <components.Menu {...props}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ width: '100%' }}>
                <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa', }}>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>Total</div>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>KnockedOff</div>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>Pending</div>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>Reference No</div>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>Date</div>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>Bank</div>
                </tr>
                {/* </tr> */}
            </thead>
            <tbody >
                {props.children}
            </tbody>
        </table>
    </components.Menu>
);